'use client';

import { c as _c } from "react/compiler-runtime";
import { getProjectProductConfig } from '@/domains/dashboard/components/project-product.config';
import { useProjectsContext } from '@/providers/projects-provider';
import Image from 'next/image';
export function SharedLinkHeader() {
  const $ = _c(15);
  const {
    selectedProject
  } = useProjectsContext();
  const projectName = selectedProject?.name ?? "(no project)";
  const projectProduct = selectedProject?.product ?? "external";
  let t0;
  if ($[0] !== projectProduct) {
    t0 = getProjectProductConfig(projectProduct);
    $[0] = projectProduct;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    icon: Icon,
    title: productTitle
  } = t0;
  let t1;
  if ($[2] !== Icon) {
    t1 = <Icon className="size-3.5" strokeWidth={2.1} aria-hidden={true} />;
    $[2] = Icon;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== productTitle || $[5] !== t1) {
    t2 = <span className="inline-flex size-7 shrink-0 items-center justify-center rounded-[8px] border border-border bg-muted text-muted-foreground" title={productTitle}>{t1}</span>;
    $[4] = productTitle;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== projectName) {
    t3 = <span className="truncate text-sm font-medium text-foreground">{projectName}</span>;
    $[7] = projectName;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="flex min-w-0 items-center gap-2.5">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image src="/images/main-logo-new.svg" height={20} width={71} alt="Nebuly" className="mb-px shrink-0" />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4) {
    t6 = <header aria-label="Shared page header" className="sticky top-0 z-10 shrink-0 border-b border-border bg-background px-8 py-3"><div className="flex items-center justify-between gap-4">{t4}{t5}</div></header>;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}